import React from 'react';
import PropTypes from 'prop-types';

export const IconPresent = ({ className }) => (
  <svg className={className} width="30" height="30" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5052 0.336609C19.0825 0.336609 21.1719 2.42595 21.1719 5.00328C21.1719 5.85381 20.9443 6.6512 20.5468 7.3379L25.8386 7.33661V9.66993H23.5052V21.3366C23.5052 21.9809 22.9829 22.5033 22.3386 22.5033H3.67188C3.02755 22.5033 2.50521 21.9809 2.50521 21.3366V9.66993H0.171875V7.33661L5.46361 7.3379C5.06609 6.6512 4.83854 5.85381 4.83854 5.00328C4.83854 2.42595 6.92788 0.336609 9.50521 0.336609C10.8996 0.336609 12.1512 0.948187 13.0063 1.91775C13.8592 0.948187 15.1108 0.336609 16.5052 0.336609ZM11.8386 9.66993H4.83854V20.1699H11.8386V9.66993ZM21.1719 9.66993H14.1719V20.1699H21.1719V9.66993ZM9.50521 2.66994C8.21654 2.66994 7.17188 3.71461 7.17188 5.00328C7.17188 6.23336 8.12374 7.24113 9.33107 7.3302L9.50521 7.33661H11.8386V5.00328C11.8386 3.83468 10.9795 2.86675 9.85845 2.69651L9.67936 2.67634L9.50521 2.66994ZM16.5052 2.66994C15.2751 2.66994 14.2673 3.6218 14.1783 4.82914L14.1719 5.00328V7.33661H16.5052C17.7352 7.33661 18.743 6.38475 18.8321 5.17741L18.8386 5.00328C18.8386 3.71461 17.7939 2.66994 16.5052 2.66994Z" fill="white" />
  </svg>
);

IconPresent.propTypes = {
  className: PropTypes.string,
};

IconPresent.defaultProps = {
  className: null,
};
